export const Waiting = () => (
  <svg fill="none" height="121" viewBox="0 0 121 121" width="121" xmlns="http://www.w3.org/2000/svg">
    <g id="Interface Waiting 01">
      <g id="Group">
        <g id="Group_2">
          <path
            d="M28.9443 85.9037L82.1367 110.699L78.8877 117.664L25.6953 92.8691L28.9443 85.9037Z"
            fill="#2ED3AE"
            id="Vector"
          />
          <path
            d="M57.8203 23.9789L54.5713 30.9557L107.752 55.7507L111.001 48.7841L57.8203 23.9789ZM78.9445 38.6507L66.5845 33.3383L67.2445 31.7879L79.6045 37.1003L78.9445 38.6507Z"
            fill="#2ED3AE"
            id="Vector_2"
          />
        </g>
        <g id="Group_3">
          <path
            d="M79.1384 109.296L31.9424 87.2945C32.736 85.5941 33.6622 83.9588 34.7126 82.4039C50.2622 89.3807 65.8004 91.4099 81.3158 86.7839C83.275 94.3094 82.5036 102.286 79.1384 109.296Z"
            fill="#1072BA"
            id="Vector_3"
          />
          <path
            d="M102.509 58.4639C95.3266 69.7157 82.6726 75.2903 71.5576 72.0299C76.4254 72.8963 92.2942 70.0241 102.509 58.4639Z"
            fill="#1072BA"
            id="Vector_4"
          />
        </g>
        <g id="Group_4">
          <path
            d="M108.014 24.7426C108.015 24.9096 107.978 25.0746 107.907 25.2256C107.835 25.3767 107.731 25.51 107.602 25.6159C107.473 25.7219 107.322 25.7978 107.16 25.8382C106.998 25.8786 106.829 25.8825 106.666 25.8496C106.389 25.7964 106.143 25.642 105.975 25.4167C105.807 25.1913 105.729 24.9113 105.756 24.6314C105.784 24.3516 105.915 24.0922 106.124 23.904C106.333 23.7157 106.605 23.6124 106.886 23.614C107.109 23.6134 107.328 23.6792 107.514 23.8032C107.7 23.9271 107.844 24.1035 107.93 24.31C107.986 24.4474 108.015 24.5944 108.014 24.7426Z"
            id="Vector_5"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.8433 38.4569L31.8857 36.0401L44.3801 31.0583L45.3491 33.4751L32.8433 38.4569Z"
            id="Vector_6"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M67.2943 24.0701L66.7812 22.7933L79.2757 17.8115L79.7887 19.0883L67.2943 24.0701Z"
            id="Vector_7"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.0345 17.3555L45.0527 4.86106L48.0395 3.66406L53.0213 16.1699L50.0345 17.3555Z"
            id="Vector_8"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M64.4213 51.8063L59.4395 39.3005L61.2977 38.5709L66.2795 51.0653L64.4213 51.8063Z"
            id="Vector_9"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.4025 24.4691L32.0449 19.1567L33.1963 16.4891L45.5539 21.8015L44.4025 24.4691Z"
            id="Vector_10"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.2776 17.5835L59.04 16.1927L64.3524 3.82367L67.59 5.21447L62.2776 17.5835Z"
            id="Vector_11"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.9791 51.6239L44.8701 50.7233L50.1825 38.3657L52.2915 39.2657L46.9791 51.6239Z"
            id="Vector_12"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.5583 32.3441C50.4783 47.5175 55.3125 64.7441 68.3427 70.8191C81.3729 76.8941 97.6749 69.5195 104.754 54.3461"
            id="Vector_13"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M107.752 55.7507L54.5713 30.9557L57.8203 23.9789L111.001 48.7853L107.752 55.7507Z"
            id="Vector_14"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.1384 109.296C86.2184 94.123 81.3842 76.8964 68.354 70.8214C55.3238 64.7464 39.0218 72.124 31.9424 87.2944"
            id="Vector_15"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.9443 85.9037L82.1367 110.699L78.8877 117.664L25.6953 92.8691L28.9443 85.9037Z"
            id="Vector_16"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.2468 82.4495L9.29102 90.8741"
            id="Vector_17"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.4809 88.6396L7.04492 84.6838"
            id="Vector_18"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.3141 86.7815C65.7987 91.4099 50.2605 89.3807 34.7109 82.4015"
            id="Vector_19"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.5459 72.0299C76.4137 72.8963 92.2825 70.0463 102.497 58.4639"
            id="Vector_20"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M109.884 82.7458L107.456 81.3664L108.835 78.9382"
            id="Vector_21"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M107.456 81.364C108.29 80.9413 109.238 80.8022 110.158 80.9679C111.078 81.1336 111.919 81.595 112.553 82.2821C113.187 82.9694 113.578 83.8451 113.669 84.7757C113.759 85.7063 113.543 86.6409 113.053 87.4372C112.687 88.0326 112.182 88.5296 111.58 88.8851C110.979 89.2406 110.299 89.4437 109.602 89.4769C108.904 89.5101 108.208 89.3723 107.576 89.0755C106.943 88.7786 106.393 88.3318 105.973 87.7739C105.41 87.0276 105.106 86.1179 105.107 85.183"
            id="Vector_22"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.9452 38.6506L66.5762 33.3382L67.2488 31.7878L79.6064 37.1002L78.9452 38.6506Z"
            id="Vector_23"
            stroke="#004A72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
